import React, { Suspense } from "react";
import 'react-confirm-alert/src/react-confirm-alert.css';

const Tenantprofile = React.lazy(() => import('./subpages/Tenantprofilecontent.jsx'));
const Tenantheader = React.lazy(() => import('./subpages/Tenantheader.jsx'));


class Ptenantprofile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            AlterpopId: "alertModel",


        };
    }

    onlogout(e) {
        // store.dispatch(replacestate(defalutreduxState));
        setTimeout(() => { this.props.history.push("/tenantlogin"); }, 100);
    }

    render() {
        return (
            <div id="idElnBody" >
                <div id="bodyAdmincontent" className="d-flex flex-column">
                    <Suspense fallback={<div></div>}>
                        <Tenantheader pageName="Organisation Details" onlogout={this.onlogout.bind(this)} />
                    </Suspense>
                    <Suspense fallback={<div></div>}>
                        <Tenantprofile />
                    </Suspense>
                </div>
            </div>
        );
    }
}
export default Ptenantprofile;

